// payment/terms/use 이용약관
import "./UseTermPage.css";

function PaymentUseTermPage() {
  return (
    <article className="use-term">
      <header>
        <h1>이용약관</h1>
        <p className="page-description"></p>
      </header>
      <div className="page-body">
        <h2>이용약관</h2>

        <div className="chapter">
          <h3>제1장 총 칙</h3>

          <h4>제1조 목적</h4>
          <p>
            이 약관은 "이규호사주TV"(이하 "회사"라 함)가 운영하는 이규호 만세력
            사이트(https://lee-saju.com/payment, 이하 "사이트"라 함) 및 회사가
            제공하는 프리미엄 사주 서비스를 포함한 일체의 관련 서비스(이하
            "서비스"라 함)의 이용조건, 절차 및 권리·의무를 규정함을 목적으로
            합니다.
          </p>

          <h4>제2조 정의</h4>
          <p>
            1. "회사"가 운영하는 "사이트"는 다음과 같으며, 아래 "사이트"는 본
            약관의 적용을 받습니다. https://lee-saju.com/payment
          </p>
          <p>
            2. "이용자"란 "회사"에 접속하여 이 약관에 따라 "회사"가 제공하는
            서비스를 받는 회원 및 비회원을 말합니다.
          </p>
          <p>
            3. "회원"이라 함은 "회사"에 개인정보를 제공하여 회원등록을 한
            자로서, "회사"의 정보를 지속적으로 제공받으며, "회사"가 제공하는
            서비스를 계속적으로 이용할 수 있는 자를 말합니다.
          </p>
          <p>
            4. "비회원"이라 함은 회원에 가입하지 않고 "회사"가 제공하는 서비스를
            이용하는 자를 말합니다.
          </p>
          <p>
            5. "유료서비스"란 "회사"가 "이용자"에게 대금을 받고 제공하는
            서비스를 말합니다.
          </p>

          <h4>제3조 약관의 공지 및 효력</h4>
          <p>
            1. 본 약관의 내용은 서비스 화면에 게시하거나 기타의 방법으로
            이용자에게 공지함으로써 효력이 발생합니다.
          </p>
          <p>
            2. 회사는 이용자를 위하여 새로운 서비스를 추가하거나 회사 정책상
            중요 사유가 있을 경우 약관을 변경할 수 있으며, 이에 대하여 전항과
            같은 방법에 의해 효력을 갖습니다.
          </p>

          <h4>제4조 약관 외 준칙</h4>
          <p>
            이 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법 및
            기타 관계법령의 규정에 의합니다.
          </p>
        </div>

        <div className="chapter">
          <h3>제2장 서비스 이용계약</h3>

          <h4>제5조 이용계약의 성립</h4>
          <p>
            이용자는 본 서비스를 이용함으로써 본 약관의 모든 내용에 동의한
            것으로 간주됩니다. 다만, 유료 결제 또는 개인정보 제공 등 주요 항목에
            대해서는 별도의 동의를 거쳐야 하며, 회사는 이를 확인 가능한
            방식(체크박스, 전자서명 등)으로 동의를 받습니다.
          </p>

          <h4>제6조 이용자정보의 공유</h4>
          <p>
            1. 회사가 타 업체와 제휴, 인수, 분사, 합병 시 이용자의 정보는 공유될
            수 있습니다.
          </p>
          <p>
            2. 회사는 회사가 제공하는 서비스를 이용하는 이용자를 대상으로 해당
            서비스의 양적, 질적 향상을 위하여 이용자에게 맞춤 서비스, 이벤트,
            인터넷 쇼핑 서비스, 커뮤니케이션 서비스, 콜센터를 통한 보험,
            통계작성 또는 시장조사 등 다양한 서비스를 제공할 목적으로 여러
            분야의 전문 컨텐츠 사업자 혹은 비지니스 사업자와 함께 파트너쉽을
            맺어 회원가입 시 입력 받은 개인정보로부터 이름이나 주소와 같은
            서비스 이용에 필요한 제한된 범위의 개인정보를 이용자의 동의를 받아
            회사의 협력업체에 제공 할 수 있습니다.
          </p>
          <p>
            3. 이용자는 회사에 제공한 개인정보의 수집과 이용에 대한 동의를
            언제든지 철회할 수 있습니다.
          </p>
          <p>
            4. 1항, 2항의 사유가 발생할 경우 회사는 이용자에게 해당 사실을
            공지해야 합니다.
          </p>

          <h4>제7조 개인정보의 보호</h4>
          <p>
            1. 회사는 이용자의 개인정보를 수집할 때 반드시 본인의 동의를
            받습니다.
          </p>
          <p>
            2. 회사는 본인의 귀책사유로 인해 개인정보가 유출되는 등 손해가
            발생한 경우, 관련 법령에 따른 책임을 부담하며, 그 손해배상 범위는
            이용자가 해당 서비스 이용을 위해 실제로 지불한 금액을 한도로 합니다.
          </p>
        </div>

        <div className="chapter">
          <h3>
            제3장 서비스 제공 및 변경, 게시물에 대한 저작권, 인공지능의 신뢰성
          </h3>

          <h4>제8조 서비스 이용</h4>
          <p>
            1. 서비스의 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한
            연중무휴 1일 24시간을 원칙으로 합니다. 단, 정기점검이나 설비의 보수,
            전기통신 사업법에 의한 기간통신사업자로 인한 서비스 중단 등의 이유로
            사전공지 후 혹은 천재지변 등 불가항력적인 사유로 사전공지 없이
            서비스가 일시 중단될 수 있습니다.
          </p>
          <p>
            2. 유료 서비스에 대한 "회사"가 작성한 저작물에 대한 저작권 기타
            지적재산권은 "회사"에 귀속합니다.
          </p>
          <p>
            3. "이용자"는 "회사"를 이용함으로써 얻은 정보 중 "회사"에게
            지적재산권이 귀속된 정보를 "회사"의 사전 승낙 없이 복제, 송신, 출판,
            배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게
            이용하게 하여서는 안됩니다.
          </p>
          <p>
            4. "회사"는 약정에 따라 "이용자"에게 귀속된 저작권을 사용하는 경우
            당해 "이용자"에게 통보하여야 합니다.
          </p>

          <h4>제9조 결제방법</h4>
          <p>1. 직접 계좌이체</p>
          <p>2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제</p>

          <h4>제10조 계약의 해지, 결제 취소 및 환불 등</h4>
          <p>
            ① 회사는 이용자가 구매 신청한 콘텐츠 서비스를 기술적인 문제 등의
            사유로 제공할 수 없을 때에는 그 사유를 이용자에게 통지하고 사전에
            콘텐츠 서비스 등의 결제가 이루어진 경우는 신속하게 이 결제를
            취소합니다.
          </p>
          <p>
            ② 회사는 결제한 구매자가 오류문의 또는 e메일을 통한 요청이 있고 그
            요청이 취소 가능한 경우에 해당하면 신속하게 그 결제를 취소합니다.
            취소 가능한 경우는 아래의 각 호와 같습니다.
          </p>
          <p>1. 유료서비스 제작하거나 제공하기 전에 취소를 요청한 경우</p>
          <p>2. 기타 오류로 정상적인 서비스를 받지 못한 경우</p>
          <p>
            ③ 이용자가 콘텐츠를 열람하거나 다운로드 등으로 실질적으로 이용한
            경우, 해당 콘텐츠에 대한 결제는 환불이 불가합니다.
          </p>
          <p>
            ④ 회사는 디지털 콘텐츠 특성상 '콘텐츠 제공이 개시된 경우'에는
            「전자상거래법」 제17조 제2항에 따라 청약 철회가 제한됨을 고지하며,
            이에 대한 동의를 받습니다.
          </p>

          <h4>제11조 개인정보보호</h4>
          <p>
            1. "회사"는 "이용자"의 개인정보 수집 시 서비스제공을 위하여 필요한
            범위에서 최소한의 개인정보를 수집합니다.
          </p>
          <p>
            2. "회사"는 "이용자"의 개인정보를 수집·이용하는 때에는 당해
            이용자에게 그 목적을 고지하고 동의를 받습니다.
          </p>
          <p>
            3. "회사"는 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며,
            새로운 이용목적이 발생한 경우 또는 제 3자에게 제공하는 경우에는
            이용제공 단계에서 당해 이용자에게 그 목적을 고지하고 동의를
            받습니다. 다만, 관련 법령에 달리 정함이 있는 경우에는 예외로 합니다.
          </p>
          <p>
            4. "회사"가 제2항과 제3항에 의해 "이용자"의 동의를 받아야 하는
            경우에는 개인정보관리 책임자의 신원(소속, 성명 및 전화번호, 기타
            연락처)정보의 수집목적 및 이용목적, 제3자에 대한 정보제공
            관련사항(제공받는자, 제공목적 및 제공할 정보의 내용) 등 「정보통신망
            이용촉진 및 정보보호 등에 관한 법률」 제22조 제2항이 규정한 사항을
            미리 명시하거나 고지해야 하며 "이용자"는 언제든지 이 동의를 철회할
            수 있습니다.
          </p>
          <p>
            5. "이용자"는 언제든지 "회사"가 가지고 있는 자신의 개인정보에 대해
            열람 및 오류정정을 요구할 수 있으며 "회사"는 이에 대해 지체 없이
            필요한 조치를 취할 의무를 집니다. "이용자"가 오류 정정을 요구한
            경우에는 "회사"는 그 오류를 정정할 때까지 당해 개인정보를 이용하지
            않습니다.
          </p>
          <p>
            6. "회사" 또는 "이용자"로부터 개인정보를 제공받은 제3자는 개인정보의
            수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체
            없이 파기합니다.
          </p>
          <p>
            7. "회사"는 개인정보의 수집·이용·제공에 관한 동의란을 미리 선택한
            것으로 설정해두지 않습니다.
          </p>

          <h4>제12조 인공지능의 신뢰성</h4>
          <p>
            1. 회사는 인공지능이 생성한 만세력테스트에 대한 모든 결과에 대해서
            신뢰성을 보장하지 않습니다. 사용자는 인공지능이 생성한 결과에 대해서
            참고용으로만 사용해야 하며, 인공지능이 생성한 결과로 인해서
            이용자에게 어떠한 손해가 발생하더라도 회사는 책임지지 않습니다.
          </p>
          <p>
            2. 회사는 이용자의 사주팔자, 명리학, 타로, 점술, 해몽, 궁합 등 널리
            알려진 운세 서비스를 인공지능을 통해 학습하여 제공합니다. 명리학,
            타로, 점술, 해몽, 궁합은 역사가 오래된 방법론이기는 하나, 과학적으로
            그 효과가 입증되지는 않았습니다. 따라서, 이용자는 이를 통해서 인생의
            중대사를 결정해서는 안됩니다. 이를 통해서 발생한 그 어떤 손해에
            대해서 회사는 책임지지 않습니다.
          </p>
          <p>
            3. 회사가 제공하는 유료/무료 서비스는 서로 다른 알고리즘 및 엔진을
            사용하므로, 결과가 다를 수 있습니다. 더불어, 같은 인공지능을 엔진을
            사용하더라도, 일부 세부적인 부분에서 매번 결과 생성 시 마다 세부
            내용이 달라질 수 있습니다.
          </p>
        </div>

        <div className="chapter">
          <h3>제4장 서비스 이용제한 및 계약해지</h3>

          <h4>제13조 서비스 이용제한</h4>
          <p>
            1. 회사는 다음에 해당하는 경우 사전통지 없이 이용자의 이용계약을
            해지하거나 또는 일정기간 서비스 이용을 제한할 수 있습니다.
          </p>
          <p>① 타인의 휴대폰번호, 생년월일 등 개인정보를 도용하는 경우</p>
          <p>② 범죄행위와 관련되는 경우</p>
          <p>③ 공공질서 및 미풍양속에 반하는 경우</p>
          <p>④ 타인의 명예를 훼손하거나 불이익을 주는 경우</p>
          <p>⑤ 서비스에 위해를 가하는 등 건전한 이용을 저해하는 경우</p>
          <p>⑥ 기타 관계법령에 위배되는 경우</p>
        </div>

        <div className="chapter">
          <h3>제5장 의 무</h3>

          <h4>제14조 회사의 의무</h4>
          <p>
            1. 회사는 제8조 및 기타 특별한 사유가 없는 한 이용자가 신청한
            서비스를 이용할 수 있도록 합니다.
          </p>
          <p>
            2. 회사는 이 약관에서 정한 바에 따라 지속적, 안정적으로 서비스를
            제공할 의무가 있습니다.
          </p>
          <p>
            3. 회사는 이용자의 개인정보를 본인의 승낙 없이 타인에게 공개,
            배포하지 않습니다. 단, 전기통신관련 법령 등 관계법령에 의해 국가기관
            등의 요구가 있는 경우, 개인의 안전을 보호해야 할 시급한 경우에는
            그러하지 않습니다.
          </p>

          <h4>제15조 이용자의 의무</h4>
          <p>
            1. 이용자는 서비스 신청·변경 시 다른 사람의 정보를 이용하거나
            허위정보를 제공해서는 안 됩니다.
          </p>
          <p>
            2. 휴대폰번호와 메일주소는 회사의 승낙 없이 다른 사람에게 양도,
            임대, 대여할 수 없습니다.
          </p>
          <p>
            3. 자신의 휴대폰번호가 부정하게 사용된 경우 이용자는 반드시 회사에
            그 사실을 E메일이나 기타 방법을 이용하여 통보해야 합니다.
          </p>
          <p>4. 이용자는 다음의 행위를 해서는 아니 됩니다.</p>
          <p>
            ① 회사를 이용하여 구입한 재화 등의 대금, 기타 "회원"이 부담하는
            채무를 기일에 지급하지 않는 경우
          </p>
          <p>② 회사 및 제3자의 저작권 등 지적재산권에 대한 침해</p>
          <p>③ 회사 및 제3자의 명예를 손상시키거나 업무를 방해하는 행위</p>
          <p>
            ④ 외설 또는 폭력적인 메시지 화상 음성 기타 공공의 질서와 선량한
            풍속에 반하는 정보를 사이트에 공개 또는 게시하는 행위
          </p>
          <p>
            ⑤ 선정적이고 음란한 내용 기타 공공질서 및 사회상규에 반하는 내용을
            게시하는 행위
          </p>
          <p>
            5. 이용자는 이 약관 및 관계법령에서 규정한 사항을 준수해야 합니다.
          </p>
        </div>

        <div className="chapter">
          <h3>제6장 손해배상 및 면책사항</h3>

          <h4>제16조 손해배상</h4>
          <p>
            회사는 AI 서비스의 신뢰성을 보장하지 않으며, AI가 생성한 컨텐츠에
            대해서 그 어떠한 책임도 지지 않습니다. 회사가 제공하는 컨텐츠로
            인하여 이용자에게 손해가 발생하는 경우에도, 회사는 이에 대해서
            책임을 지지 않습니다.
          </p>

          <h4>제17조 분쟁해결</h4>
          <p>
            1. 회사는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로
            반영하여 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게
            그 사유와 처리일정을 즉시 통보해 줍니다.
          </p>
          <p>
            2. 회사와 이용자간에 발생한 분쟁과 관련하여 이용자의 피해구제신청이
            있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는
            분쟁조정기관의 조정에 따를 수 있습니다.
          </p>
          <p>
            3. 회사와 이용자 간에 발생한 위치정보 분쟁과 관련하여 당사자간
            협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에 위치정보법
            제28조 규정에 의한 방송통신위원회 재정을 신청하거나 개인정보보호법
            제43조 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수
            있습니다.
          </p>

          <h4>제18조 면책사항</h4>
          <p>
            1. 회사는 천재지변 및 이에 준하는 불가항력으로 인하여 서비스를
            제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
          </p>
          <p>
            2. 회사는 이용자가 서비스에 게재한 정보 및 자료의 신뢰성, 정확성 등
            내용에 관하여는 책임을 지지 않습니다.
          </p>
          <p>
            3. 휴대폰번호와 이메일 주소 관리 및 이용상의 부주의로 인하여
            발생되는 손해 또는 제3자에 의한 부정사용 등에 대한 모든 책임은
            이용자에게 있습니다.
          </p>
          <p>
            4. 이용자가 제8조 및 기타 약관에 규정된 사항을 위반하여 회사가
            이용자 또는 제3자에 대하여 책임을 부담하고 이로 인해 회사에 손해가
            발생한 경우, 이 약관을 위반한 이용자는 회사가 입은 모든 손해를
            배상하여야 하며 동 손해로부터 회사를 면책시켜야 합니다.
          </p>

          <h4>제19조 회사 리소스 무단 사용에 대한 조치</h4>
          <p>
            양력/음력 변화, 만세력 조회, AI 운세 서비스 등 제 3자가 스크립트
            등을 이용하여, 회사의 서버 리소스, AI 리소스(GPU 등) 등을 무단
            사용한 경우, 민사 및 형사 책임을 동시에 집니다. 특히나, 회사의
            리소스를 무단으로 사용하는 경우 손해배상액은 다음 중 큰 것으로
            합니다.
          </p>

          <h4>제20조 재판권 및 준거법</h4>
          <p>
            1. 회사와 이용자간에 발생한 분쟁에 관한 소송은 제소 당시의 회사의
            주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의
            전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가
            분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에
            제기합니다.
          </p>
          <p>2. 회사와 이용자간에 제기된 소송에는 대한민국법을 적용합니다.</p>
        </div>

        <div className="effective-date">
          이 약관은 2025년 7월 11일부터 시행합니다.
        </div>
      </div>
    </article>
  );
}

export default PaymentUseTermPage;
